import "./App.css";
import React, { Suspense, lazy, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// AOS Animations
import AOS from "aos";
import "aos/dist/aos.css";
import PrivacyPolicy from "./pages/FooterPolicies/PrivacyPolicy";
import TermsAndConditions from "./pages/FooterPolicies/TermsAndConditions";
import CookiePolicy from "./pages/FooterPolicies/CookiePolicy";
import Disclaimer from "./pages/FooterPolicies/Disclaimer";
import LegalAndCompliance from "./pages/FooterPolicies/LegalAndCompliance";
import CookiesPopup from "./components/CookiesPopup";

AOS.init();

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the route changes
  }, [location]);
  return null;
}
const Header = lazy(() => import("./components/Header"));
const Footer = lazy(() => import("./components/Footer"));
const Home = lazy(() => import("./pages/Home/Home"));
const Aboutus = lazy(() => import("./pages/Aboutus/Aboutus"));
const Product = lazy(() => import("./pages/Product/Product"));
const Training = lazy(() => import("./pages/Training/Training"));
const Talk = lazy(() => import("./pages/Talk/Talk"));
const Competencies = lazy(() => import("./pages/Competencies/Competencies"));
const SpecialisedServices = lazy(
  () => import("./pages/SpecialisedServices/SpecialisedServices")
);

function App() {
  return (
    <Router>
      <div>
        <ScrollToTop /> {/* Scroll to top on route change */}
        <Header />
        <CookiesPopup />
        <Suspense fallback={<div className="text-center p-4">Loading...</div>}>
          <Routes>
            <Route path="*" element={<Home />} />
            <Route exact path="/" element={<Home />} />
            <Route exact path="/training" element={<Training />} />
            <Route exact path="/contact" element={<Talk />} />
            <Route exact path="/products" element={<Product />} />
            <Route exact path="/aboutus" element={<Aboutus />} />
            <Route exact path="/competencies" element={<Competencies />} />
            <Route
              exact
              path="/specialised-services"
              element={<SpecialisedServices />}
            />

            {/* Footer Policy Routes */}
            <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              exact
              path="/terms-conditions"
              element={<TermsAndConditions />}
            />
            <Route exact path="/cookie-policy" element={<CookiePolicy />} />
            <Route exact path="/legal-disclaimer" element={<Disclaimer />} />
            <Route
              exact
              path="/legal-compliance"
              element={<LegalAndCompliance />}
            />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
